import { NSMenuActionProps } from "namirasoft-site-react";
import { TelegramSenderRoutes } from "./TelegramSenderRoutes";
import { ProviderRow } from "namirasoft-telegram-sender";

export class TelegramSenderMenus
{
	static verify(getIDs: () => string[], getRows: (() => ProviderRow[])): NSMenuActionProps
	{
		return {
			id: "1",
			menu_item: "Verify",
			isActive: () =>
			{
				if (getIDs().length === 1)
				{
					let rows = getRows();
					if (rows)
						if (rows.length > 0)
							return !rows[0].e_verified;
				}
				return false;
			},
			onClick: {
				action: () =>
				{
					let id = getIDs()[0];
					window.location.href = TelegramSenderRoutes.Verify(id);
				},
				showLoading: false
			}
		}
	}
	static send(getIDs: () => string[], getRows: (() => ProviderRow[])): NSMenuActionProps
	{
		return {
			id: "2",
			menu_item: "Send",
			isActive: () =>
			{
				if (getIDs().length === 1)
				{
					let rows = getRows();
					if (rows)
						if (rows.length > 0)
							return rows[0].e_verified;
				}
				return false;
			},
			onClick: {
				action: () =>
				{
					let id = getIDs()[0];
					window.location.href = TelegramSenderRoutes.Send(id);
				},
				showLoading: false
			}
		}
	}
}